import Navbar from "@/sections/Navbar";
import Footer from "@/sections/Footer";
import { Eyebrow } from "@/lib/motion";

// Renders a legal document from structured content.
export default function LegalLayout({ title, updated, intro, sections, testId }) {
  return (
    <div className="bg-brand-cream text-brand-ink font-body antialiased min-h-screen" data-testid={testId}>
      <Navbar />
      <main className="pt-28 md:pt-36 pb-8">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Eyebrow>Legal</Eyebrow>
          <h1 className="mt-6 font-display font-normal text-4xl sm:text-5xl lg:text-6xl tracking-tight">{title}</h1>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.15em] text-brand-ink/50">Last updated: {updated}</p>

          {intro && <p className="mt-8 text-lg leading-relaxed text-brand-ink/75">{intro}</p>}

          <div className="mt-12 space-y-10">
            {sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-display text-2xl md:text-3xl mb-4">
                  <span className="text-brand-teal mr-2">{String(i + 1).padStart(2, "0")}.</span>
                  {s.heading}
                </h2>
                {s.paragraphs?.map((p, j) => (
                  <p key={j} className="text-brand-ink/75 leading-relaxed mb-4">{p}</p>
                ))}
                {s.list && (
                  <ul className="space-y-2 mb-4">
                    {s.list.map((li, k) => (
                      <li key={k} className="flex items-start gap-3 text-brand-ink/75">
                        <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-apricot shrink-0" />
                        <span>{li}</span>
                      </li>
                    ))}
                  </ul>
                )}
                {s.subsections?.map((sub, s2) => (
                  <div key={s2} className="mt-6">
                    <h3 className="font-display text-xl mb-3 text-brand-teal">{sub.sub}</h3>
                    {sub.paragraphs?.map((p, j) => (
                      <p key={j} className="text-brand-ink/75 leading-relaxed mb-3">{p}</p>
                    ))}
                    {sub.list && (
                      <ul className="space-y-2 mb-3">
                        {sub.list.map((li, k) => (
                          <li key={k} className="flex items-start gap-3 text-brand-ink/75">
                            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-apricot shrink-0" />
                            <span>{li}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </section>
            ))}
          </div>

          <div className="mt-14 rounded-2xl border border-brand-peach bg-brand-peach/40 p-6">
            <p className="text-brand-ink/80">
              Questions about this document? Email us at{" "}
              <a href="mailto:hello@peachflowai.com" className="text-brand-teal underline underline-offset-4">hello@peachflowai.com</a>.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
